/*
 * ווידג'ט נגישות — סרגל כלים נגיש ומתמשך (נשמר ב-localStorage בין עמודים).
 * מפעיל מחלקות על <html> שמעוצבות ב-floating-widgets.css.
 */
(function () {
  "use strict";

  var STORAGE_KEY = "wt_a11y_prefs";
  var root = document.documentElement;

  // state
  var state = { fs: 0, contrast: false, invert: false, links: false, readable: false, noanim: false };

  function load() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      if (raw) state = Object.assign(state, JSON.parse(raw));
    } catch (e) {}
  }
  function save() {
    try { window.localStorage.setItem(STORAGE_KEY, JSON.stringify(state)); } catch (e) {}
  }

  function apply() {
    root.classList.remove("wt-a11y-fs-1", "wt-a11y-fs-2", "wt-a11y-fs-3");
    if (state.fs > 0) root.classList.add("wt-a11y-fs-" + state.fs);
    root.classList.toggle("wt-a11y-contrast", !!state.contrast);
    root.classList.toggle("wt-a11y-invert", !!state.invert);
    root.classList.toggle("wt-a11y-links", !!state.links);
    root.classList.toggle("wt-a11y-readable", !!state.readable);
    root.classList.toggle("wt-a11y-noanim", !!state.noanim);
  }

  function reflectButtons(scope) {
    var opts = scope.querySelectorAll("[data-a11y]");
    opts.forEach(function (btn) {
      var k = btn.getAttribute("data-a11y");
      var on = false;
      if (k === "bigger" || k === "smaller") on = state.fs > 0 && k === "bigger";
      else if (state.hasOwnProperty(k)) on = !!state[k];
      if (k !== "bigger" && k !== "smaller" && k !== "reset") {
        btn.setAttribute("aria-pressed", on ? "true" : "false");
      }
    });
  }

  function handle(k) {
    switch (k) {
      case "bigger": state.fs = Math.min(3, state.fs + 1); break;
      case "smaller": state.fs = Math.max(0, state.fs - 1); break;
      case "contrast": state.contrast = !state.contrast; if (state.contrast) state.invert = false; break;
      case "invert": state.invert = !state.invert; if (state.invert) state.contrast = false; break;
      case "links": state.links = !state.links; break;
      case "readable": state.readable = !state.readable; break;
      case "noanim": state.noanim = !state.noanim; break;
      case "reset": state = { fs: 0, contrast: false, invert: false, links: false, readable: false, noanim: false }; break;
    }
    apply(); save();
  }

  function initWidget(wrap) {
    var toggle = wrap.querySelector(".wt-fw-a11y__toggle");
    var panel = wrap.parentNode.querySelector(".wt-a11y-panel") || document.getElementById("wt-a11y-panel");
    if (!toggle || !panel) return;

    function openPanel() {
      panel.hidden = false;
      toggle.setAttribute("aria-expanded", "true");
      reflectButtons(panel);
      var first = panel.querySelector("[data-a11y], .wt-a11y-panel__close");
      if (first) first.focus();
    }
    function closePanel(refocus) {
      panel.hidden = true;
      toggle.setAttribute("aria-expanded", "false");
      if (refocus) toggle.focus();
    }
    function isOpen() { return !panel.hidden; }

    toggle.addEventListener("click", function () { isOpen() ? closePanel(true) : openPanel(); });

    var closeBtn = panel.querySelector(".wt-a11y-panel__close");
    if (closeBtn) closeBtn.addEventListener("click", function () { closePanel(true); });

    panel.addEventListener("click", function (e) {
      var btn = e.target.closest("[data-a11y]");
      if (!btn) return;
      handle(btn.getAttribute("data-a11y"));
      reflectButtons(panel);
    });

    document.addEventListener("keydown", function (e) {
      if ((e.key === "Escape" || e.keyCode === 27) && isOpen()) closePanel(true);
    });
    document.addEventListener("click", function (e) {
      if (isOpen() && !panel.contains(e.target) && !toggle.contains(e.target)) closePanel(false);
    });
  }

  function boot() {
    load();
    apply();
    var wraps = document.querySelectorAll(".wt-floating-widgets");
    wraps.forEach(initWidget);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
